const approveStatuses = [
  {
    statusId: 0,
    title: ' не проверен',
    cssClass: '',
  },
  {
    statusId: 1,
    title: 'Проверен',
    cssClass: 'c-text--color-success',
  },
  {
    statusId: 2,
    title: 'Отказано',
    cssClass: 'c-text--color-danger',
  },
  {
    statusId: 3,
    title: 'Отказано',
    cssClass: 'c-text--color-danger',
  },
  {
    statusId: 4,
    title: ' не проверен',
    cssClass: '',
  },
]

const buttonsDescriptions = {
  confirm: {
    title: 'Установить как проверен',
    nextStatusId: 1,
    type: 'success',
  },
  deny: {
    title: 'Отказать в аккредитации',
    nextStatusId: 2,
    type: 'danger',
  },
  reConfirm: {
    title: 'Повторно на проверку',
    nextStatusId: 4,
    type: 'warning',
  },
  denyConfirm: {
    title: 'Снять проверку',
    nextStatusId: 3,
    type: 'warning',
  },
}

const denyAccreditationMessages = [
  {
    shortText: 'Документы',
    fullText: 'Несоответствие документов',
  },
]

const checkFailStatuses = status => [2, 3].includes(Number(status)) // Статусы "Отказано"

export {
  approveStatuses,
  buttonsDescriptions,
  checkFailStatuses,
  denyAccreditationMessages,
}
